import React from "react"
import { faSpinner } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function NewLoadingComponent(props) {
  return (
    <div
      style={{
        width: "80vw",
        display: "flex",
        flexDirection: props.flexDirection,
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <br />
      <br />
      <FontAwesomeIcon icon={faSpinner} size={"2x"} spin />
    </div>
  )
}

NewLoadingComponent.defaultProps = {
  flexDirection: "column"
}
